import { render, staticRenderFns } from "./myAddr.vue?vue&type=template&id=16d30a82&scoped=true"
import script from "./myAddr.vue?vue&type=script&lang=js"
export * from "./myAddr.vue?vue&type=script&lang=js"
import style0 from "./myAddr.vue?vue&type=style&index=0&id=16d30a82&prod&lang=scss"
import style1 from "./myAddr.vue?vue&type=style&index=1&id=16d30a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d30a82",
  null
  
)

export default component.exports